import Vue from 'vue';
import VueI18n from 'vue-i18n';
import DI from 'myra-ui-common/services/DI';
import common from 'myra-ui-common/i18n/common';
import routes from '../i18n/routes';
import merge from 'myra-ui-common/utils/mergeObjects';

// needs to be called here otherwise there will be errors thrown
Vue.use(VueI18n);

DI.service(
    'i18n',
    function (localStorageService) {
        let messages = {};

        messages = merge(messages, common);
        messages = merge(messages, routes);

        const dateTimeFormats = {
            en : {
                short : {
                    year  : 'numeric',
                    month : 'long',
                    day   : 'numeric',
                },
                long : {
                    year    : 'numeric',
                    month   : 'long',
                    day     : 'numeric',
                    weekday : 'short',
                    hour    : 'numeric',
                    minute  : 'numeric',
                    hour12  : true,
                },
            },
            de : {
                short : {
                    year  : 'numeric',
                    month : 'long',
                    day   : 'numeric',
                },
                long : {
                    year    : 'numeric',
                    month   : 'long',
                    day     : 'numeric',
                    weekday : 'short',
                    hour    : 'numeric',
                    minute  : 'numeric',
                },
            },
        };

        return new VueI18n({
            locale         : localStorageService.get('locale') || 'en',
            fallbackLocale : 'en',
            messages       : messages,
            dateTimeFormats,
        });
    },
    'localStorage'
);
